<template>
	<div class="mainNewsForm">
		<div class="flex flex-wrap mb-4">
			<div class="w-2/3 h-12 titulo">
				<h1>{{$t('Noticias')}}</h1>
			</div>
			<div class="w-1/3 h-12">
				<router-link :to="{name: 'list-news'}">
                    <vs-button class="float-right mt-2" color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left">{{$t('returnButton')}}</vs-button>
                </router-link>
			</div>
		</div>

		<div class="mt25">
			<vs-tabs alignment="fixed" class="fix-layer">
				<vs-tab :label="$t('Noticia')">
					<div class="mt15">
						<vx-card>
							<vs-tabs alignment="fixed">
								<vs-tab v-for="(lang, index) in news_form.langs" :key="index" :label="index" >

									<vs-row vs-w="12">
									    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
								            <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder inputNews">
								                <div class="vx-col w-full">
											      	<vs-input class="w-full" label-placeholder="Título" v-model="news_form.langs[index]['news']['titulo']" />
											    </div>
								            </div>

                                            <quill-editor v-model="news_form.langs[index]['news']['descricao']" :options="editorOption" class="editorSpace">
                                                <div id="toolbar" slot="toolbar">
                                                    
                                                </div>
                                            </quill-editor>
                                            
									    	<div class="vx-col w-full otherInputNews">
										      	<vs-input class="w-full" label-placeholder="Vídeo" v-model="news_form.langs[index]['news']['video']" />
										    </div>

									    </vs-col>
									    <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                                            <vs-col class="giveSpaceNews" vs-type="flex" vs-justify="center" vs-align="center">
                                                <vs-button class="mt-5 mb20" v-on:click="addFiles('image_files', index)" v-if="lang['i_files']['image_files'].length == 0" color="primary" type="filled" icon-pack="feather" icon="icon-image">{{$t('Imagem')}}</vs-button>

                                                <div v-if="lang['i_files']['image_files'].length > 0">
                                                    <vs-chip @click="removeFile(0, 'image_files', index)" closable color="primary" close-icon="close">
                                                        <vs-avatar :src="(typeof lang['i_files']['image_files'][0]['from_db'] === 'undefined') ? generatePath(lang['i_files']['image_files'][0]) : lang['i_files']['image_files'][0]['path']" @click="popupN('img', lang['i_files']['image_files'][0])" text="Imagem"/>
                                                        {{ lang['i_files']['image_files'][0]['name'] }}
                                                    </vs-chip>
                                                </div>
    											<div class="hidden sm:hidden md:hidden lg:hidden">
    												<label>
    													<input type="file" :id="'fileImg_'+index" :ref="'image_files_'+index" v-on:change="handleFileUploads('image_files', index)"/>
    												</label>
    											</div>
                                            </vs-col>
                                        </vs-col>
                                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                                            <vs-col class="giveSpaceNews notSidebySide" vs-type="flex" vs-justify="center" vs-align="center">
    								        	
                                                <vs-button class="mt-5 mb20" v-on:click="addFiles('docs_files', index)" v-if="lang['i_files']['docs_files'].length < 3" color="primary" type="filled" icon-pack="feather" icon="icon-file-plus">{{$t('Ficheiros')}}</vs-button>
                                                <div v-if="lang['i_files']['docs_files'].length > 0">
                                                    <div v-for="(file, key2) in lang['i_files']['docs_files']" :key="key2">
                                                        <vs-chip @click="removeFile(key2, 'docs_files', index)" closable color="primary" close-icon="close">
                                                            <vs-avatar color="primary" icon-pack="feather" icon="icon-file-text" @click="popupN('doc', lang['i_files']['docs_files'][key2])" />
                                                            {{ file.name }}
                                                        </vs-chip>
                                                    </div>
                                                </div>
    											<div class="hidden sm:hidden md:hidden lg:hidden">
													<input type="file" :id="'fileDoc_'+index" :ref="'docs_files_'+index" v-on:change="handleFileUploads('docs_files', index)"/>
    											</div>
                                            </vs-col>
									    </vs-col>
									</vs-row>
								        
								</vs-tab>
								
							</vs-tabs>
							<vs-divider border-style="dashed"/>
                            <vs-row vs-w="12" class="mb15 datasLimiteDiv">
                                <vs-col class="datasLimite" vs-lg="6" vs-md="6" vs-sm="12" vs-xs="12">
                                    <datepicker :disabledDates="disabledDatesInicio" :highlighted="highlightedFn" :class="(news_form['data_inicio'] == null) ? 'mr25' : ''" v-model="news_form['data_inicio']" :placeholder="$t('Data_de_Início')" format="dd/MM/yyyy"></datepicker>
                                    <feather-icon @click="clearDate('data_inicio')" v-if="news_form['data_inicio'] != null" icon="XIcon" class="cursor-pointer r30"></feather-icon>
                                </vs-col>
                                <vs-col class="datasLimite" vs-lg="6" vs-md="6" vs-sm="12" vs-xs="12">
                                    <datepicker :disabledDates="disabledDatesFim" :highlighted="highlightedFn" :class="(news_form['data_fim'] == null) ? 'mr25' : ''" v-model="news_form['data_fim']" :placeholder="$t('Data_de_Fim')" format="dd/MM/yyyy"></datepicker>
                                    <feather-icon @click="clearDate('data_fim')" v-if="news_form['data_fim'] != null" icon="XIcon" class="cursor-pointer r30"></feather-icon>
                                </vs-col>
                            </vs-row>
							<vs-row class="flex flex-wrap">
						        <div class="bottomInputs lg:w-1/4 sm:w-1/2 md:w-1/2">
                                    <vs-checkbox v-model="news_form['visivel']">{{$t('Visivel')}}</vs-checkbox>
						        </div>
						        <div class="bottomInputs lg:w-1/4 sm:w-1/2 md:w-1/2">
						        	<vs-checkbox v-model="news_form['upload']">{{$t('Upload')}}</vs-checkbox>
						        </div>
						        <div class="bottomInputs lg:w-1/4 sm:w-1/2 md:w-1/2">
						        	<vs-checkbox v-model="news_form['destaque']">{{$t('Destaque')}}</vs-checkbox>
						        </div>
						        <div class="bottomInputs lg:w-1/4 sm:w-1/2 md:w-1/2">
						        	<ul class="centerx">
							        	<li>
							        		<vs-radio v-model="news_form['tipo']" vs-name="news_tipo" vs-value="1">{{$t('Pública')}}</vs-radio>
							        	</li>
							        	<li>
							        		<vs-radio v-model="news_form['tipo']" vs-name="news_tipo" vs-value="2">{{$t('Privada')}}</vs-radio>
							        	</li>
						        	</ul>
						        </div>
						    </vs-row>
                            <vs-row class="mt25" v-if="this.id_news != null">
                                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                                    <feather-icon icon="ThumbsUpIcon" class="mr10"></feather-icon>
                                    <span class="font-bold mr40">{{news_form['likes']}}</span>
                                    <feather-icon icon="ThumbsDownIcon" class="mr10"></feather-icon>
                                    <span class="font-bold">{{news_form['dislikes']}}</span>
                                </vs-col>
                            </vs-row>
						</vx-card>
					</div> 
 
                    <vs-popup :title="popupShow.title" :active.sync="popupShow.show" class="wPopupShow">
                        <img :src="popupShow.imgSrc" class="w-full" v-if="popupShow.content == 'img'" />
                        <embed :src="popupShow.docSrc" width="960px" height="530px" v-if="popupShow.content == 'doc'" />
                    </vs-popup>
				</vs-tab>
				  
                <vs-tab :label="'Comentários ('+(!news_form.comments ? 0 : Object.keys(news_form.comments).length )+')'" v-if="this.id_news != null" :disabled="news_form.comments && Object.keys(news_form.comments).length == 0" >
                    <div class="mt15">
                        <vx-card>

                            <ul class="email__mails comentario" v-for="(com, index) in news_form.comments" :key="index">
                                <!-- comment -->
                                <li class="email__mail-item">
                                    <div class="mail__mail-item sm:px-4 px-2 py-6 mail__opened-mail">
                                        <div class="flex w-full">
                                            <vs-avatar class="mr-3" :class="( com.author.staff == null ? 'fs26' : null )" :text="com.author.nome" size="45px" color="primary" :src="require('@/assets/images/portrait/small/img_user_default.png')"/>
                                            <div class="md:flex w-full justify-between items-start mt-2">
                                                <div class="mail__details">
                                                    <h5 class="mb-1 font-bold cursor-pointer" :class="(com.visible == 0) ? 'colorG' : ''">{{com.author.nome}}</h5>
                                                    <span class="font-semibold" :class="(com.visible == 0) ? 'colorG' : ''" v-html="(com.author.loyalty_staff_card == null ? 'Cliente' : ( com.author.staff == null ? 'STAFF' : com.author.staff.department.name ))"></span>
                                                </div>
                                                <div class="mail-item__meta flex items-center">
                                                    <span :class="(com.visible == 0) ? 'colorG' : ''">{{com.created_date}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-full">
                                            <div class="mail__message textComment" :class="(com.visible == 0) ? 'colorG' : ''">
                                                <span>{{com.comment_text}}</span>
                                            </div>
                                            <div class="w-full" v-if="com.image_path">
                                                <img class="comment_image" :src="com.image_path">
                                            </div>
                                            <div class="w-full flex mt-4">
                                                <!-- icons -->
                                                <div class="flex pr15" v-if="!com.hasOwnProperty('reply') && com.author.cod_pessoa != user_name.id">
                                                    <vx-tooltip text="Responder">
                                                        <vs-button v-on:click="replyC(index)" radius color="primary" type="filled" icon-pack="feather" v-bind:icon="replyComment != index ? 'icon-corner-down-right' : 'icon-corner-left-up'"></vs-button>
                                                    </vx-tooltip>
                                                </div>
                                                <div class="flex pr15">
                                                    <vx-tooltip :text="com.visible == 1 ? 'Não Visível' : 'Visível'">
                                                        <vs-button v-on:click="changeVisibleC(com.news_comment_id, com.visible^1)" radius color="primary" type="filled" icon-pack="feather" v-bind:icon="com.visible == 1 ? 'icon-eye-off' : 'icon-eye'"></vs-button>
                                                    </vx-tooltip>
                                                </div>
                                                <!-- /icons -->
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!-- /comment -->
                            
                                <!-- textarea -->
                                <li class="cursor-pointer email__mail-item pl10p flex w-full pr1r" v-if="replyComment == index">
                                    <vs-textarea v-model="comment_text" :label="user_name.name" :placeholder="$t('Comentario')" />
                                    <div class="flex pl15">
                                        <vs-button v-on:click="sendC(index, com.news_comment_id)" radius color="primary" type="filled" icon-pack="feather" icon="icon-send"></vs-button>
                                    </div>
                                </li>
                                <!-- /textarea -->

                                <!-- reply -->
                                <li class="cursor-pointer email__mail-item pl10p" v-if="com.hasOwnProperty('reply')">
                                    <div class="mail__mail-item sm:px-4 px-2 pb15r mail__opened-mail">
                                        <div class="flex w-full">
                                            <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-corner-down-right null"></i>
                                            <vs-avatar class="mr-3" :text="com.reply.author.nome" size="70px" color="primary" :src="require('@/assets/images/portrait/small/img_user_default.png')"/>
                                            <div class="md:flex w-full justify-between items-start mt15">
                                                <div class="mail__details">
                                                    <h5 class="mb-1 font-bold">{{com.reply.author.nome}}</h5>
                                                    <span class="font-semibold" v-html="(com.reply.author.loyalty_staff_card == null ? 'Cliente' : ( com.reply.author.staff == null ? 'STAFF' : com.reply.author.staff.department.name ))"></span>
                                                </div>
                                                <div class="mail-item__meta flex items-center">
                                                    <span>{{com.reply.created_date}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex w-full ml15 textComment">
                                            <div class="mail__message">
                                                <span>{{com.reply.comment_text}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!-- /reply -->
                            </ul>
                            
                        </vx-card>
                    </div>
                </vs-tab>

                <vs-tab :label="$t('Questionario')">
                    <div class="mt15">
                        <vx-card>
                            <div :class="{ 'mb80': !this.news_form.langs[this.$i18n.locale.toUpperCase()].questions[0].hasOwnProperty('in_db')}" v-if="this.id_news != null">
                                <div class="vx-row mb20" v-for="(quest, key) in this.news_form.questions" :key="key">
                                    <div class="lg:w-2/5 w-full">
                                        <vx-card>
                                            <div class="vx-card__header question_text">
                                                <div class="vx-card__title">
                                                    <h4>{{quest.question}}</h4>
                                                </div>
                                            </div>
                                        </vx-card>
                                    </div>
                                    <div class="lg:w-3/5 w-full">
                                        <vx-card>
                                            <div class="vx-card__collapsible-content vs-con-loading__container">
                                                <div class="vx-card__body">
                                                    <table class="w-full" v-for="(resp, key2) in quest.answers" :key="key2">
                                                        
                                                        <tr class="font-semibold">
                                                            <td class="w80p">{{resp.answer}}</td>
                                                            <td class="w20p" :style="( resp.votes == 0 ? 'visibility:hidden;' : '' )">
                                                                <vs-button class="p0020 w-full" @click="popupV(key, key2)" type="line">Ver</vs-button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="w80p">
                                                                <vs-progress class="mb10" :height="10" :percent="resp.percentage" color="primary"></vs-progress>
                                                            </td>
                                                            <td class="w20p">
                                                                <div class="mb15" vs-lg="12" vs-sm="12" vs-xs="12">
                                                                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" class="font-bold">{{resp.percentage}}%</vs-col>
                                                                    <vs-col vs-type="flex" vs-justify="center" vs-align="center">{{resp.votes}} Voto(s)</vs-col>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        
                                                    </table>
                                                </div>
                                                <!---->
                                            </div>
                                        </vx-card>
                                    </div>
                                </div>
                            </div>
                            <vs-tabs alignment="fixed" class="questInputs">
                                <vs-tab class="mb20" v-for="(lang, index) in news_form.langs" :key="index" :label="index">

                                    <div class="vx-row mb10 plr20" v-for="(quest, key) in lang.questions" :key="key">
                                        <div class="lg:w-2/5 w-full">
                                            <vx-card class="pb25">
                                                <div class="card-title">

                                                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder inputNews">
                                                        <div class="vx-col w-full">
                                                            <vs-input class="w-full" label-placeholder="Pergunta" v-model="news_form.langs[index]['questions'][key]['question']" />
                                                        </div>
                                                        <vs-col class="mt15" vs-lg="12" vs-sm="12" vs-xs="12">
                                                            <p class="mb15">{{$t('Tipo')}}:</p>
                                                            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                                                                <vs-radio v-model="news_form.langs[index]['questions'][key]['question_type']" :disabled="( news_form.langs[index]['questions'][key]['news_question_id'] != null ? true : false )" :vs-name="'question_type_'+key" vs-value="1" class="mr15">{{$t('Resposta1')}}</vs-radio>
                                                                <vs-radio v-model="news_form.langs[index]['questions'][key]['question_type']" :disabled="( news_form.langs[index]['questions'][key]['news_question_id'] != null ? true : false )" :vs-name="'question_type_'+key" vs-value="2">{{$t('Várias_Opções')}}</vs-radio>
                                                            </vs-col>
                                                        </vs-col>
                                                    </div>

                                                </div>
                                            </vx-card>
                                        </div>
                                        <div class="lg:w-3/5 w-full">
                                            <vx-card>
                                                <div class="vx-card__collapsible-content vs-con-loading__container">
                                                    <div class="vx-card__body">
                                                        <table class="w-full">
                                                            
                                                            <tr class="font-semibold" v-for="(resp, chave) in quest.answer" :key="chave">
                                                                <div class="vx-col w-full">
                                                                    <vs-input class="w-full mt25i" :label-placeholder="$t('Resposta')" v-model="quest.answer[chave].option_text" />
                                                                </div>
                                                            </tr>

                                                            <vs-avatar v-if="quest.answer.length < 10 && quest.news_question_id == null" class="mt15" color="success" icon-pack="feather" icon="icon-plus" v-on:click="addAnswer(index, key)" />
                                                            <vs-avatar v-if="quest.answer.length > 2 && quest.news_question_id == null" class="mt15" color="danger" icon-pack="feather" icon="icon-minus" v-on:click="removeAnswer(index, key)" />
        
                                                        </table>
                                                    </div>
                                                </div>
                                            </vx-card>
                                        </div>
                                    </div>
                                    <vs-avatar v-on:click="addQuestion(index)" v-if="lang.questions.length < 10" class="mb25i" color="success" icon-pack="feather" icon="icon-plus" />
                                    <vs-avatar v-on:click="removeQuestion(index)" v-if="lang.questions.length > totalExistingQuestions[index]" class="mb25i" color="danger" icon-pack="feather" icon="icon-minus" />
                                </vs-tab>
                            </vs-tabs>

                            <vs-popup :title="$t('Resposta')+': '+popupVotes.title" :active.sync="popupVotes.show">
                                <div class="flex w-full" v-for="(vote, index) in popupVotes.voters" :key="index">
                                    <vs-avatar class="mr-3" :text="vote.name" size="70px" color="primary" :src="require('@/assets/images/portrait/small/img_user_default.png')" />
                                    <div class="flex w-full justify-between items-start mt15">
                                        <div class="mail__details">
                                            <h5 class="mb-1 font-semibold">{{vote.name}}</h5>
                                            <span v-html="( vote.department == null ? 'Cliente' : vote.department )"></span>
                                        </div>
                                    </div>
                                </div>
                            </vs-popup>

                        </vx-card>
                    </div>
                </vs-tab>
            </vs-tabs>

    		<div class="w-full" v-if="this.id_news == null">	
	            <vs-button v-on:click="submitNews('create')" class="ml-3 mb-2" color="primary" type="filled" icon-pack="feather" icon="icon-save">{{$t('Guardar')}}</vs-button>
	        </div>
            <div class="w-full" v-if="this.id_news != null">    
                <vs-button v-on:click="submitNews('edit')" class="ml-3 mb-2" color="primary" type="filled" icon-pack="feather" icon="icon-save">{{$t('Guardar')}}</vs-button>
            </div>
		</div>
	</div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import quill from 'quill';
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import {quillEditor} from 'vue-quill-editor';
    //import fonts from 'quill/formats/font';
    const fonts = quill.import('formats/font');
    fonts.whitelist = ['montserrat', 'arial', 'comicsans', 'inconsolata', 'monospace', 'serif'];
    quill.register(fonts, true);


	export default {
		data(){
			return {
                user_name: JSON.parse(localStorage.getItem('userSession')),
                news_form:{
                    visivel: true,
                    data_inicio: null,
                    data_fim: null,
                    upload: false,
                    destaque: false,
                    tipo: '2',
                    likes: 0,
                    dislikes: 0,
                    langs: {
                        PT: {
                            id: null,
                            news: {
                                titulo: '',
                                descricao: '',
                                video: ''
                            },
                            i_files: {
                                image_files: [],
                                docs_files: []
                            },
                            questions: [
                                {   
                                    news_question_id: null,
                                    question_type: '1',
                                    question: '',
                                    answer: [
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        },
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        }
                                    ]
                                }
                            ]
                        },
                        EN: {
                            id: null,
                            news: {
                                titulo: '',
                                descricao: '',
                                video: ''
                            },
                            i_files: {
                                image_files: [],
                                docs_files: []
                            },
                            questions: [
                                {   
                                    news_question_id: null,
                                    question_type: '1',
                                    question: '',
                                    answer: [
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        },
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        }
                                    ]
                                }
                            ]
                        },
                        DE: {
                            id: null,
                            news: {
                                titulo: '',
                                descricao: '',
                                video: ''
                            },
                            i_files: {
                                image_files: [],
                                docs_files: []
                            },
                            questions: [
                                {   
                                    news_question_id: null,
                                    question_type: '1',
                                    question: '',
                                    answer: [
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        },
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        }
                                    ]
                                }
                            ]
                        },
                        ES: {
                            id: null,
                            news: {
                                titulo: '',
                                descricao: '',
                                video: ''
                            },
                            i_files: {
                                image_files: [],
                                docs_files: []
                            },
                            questions: [
                                {   
                                    news_question_id: null,
                                    question_type: '1',
                                    question: '',
                                    answer: [
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        },
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        }
                                    ]
                                }
                            ]
                        },
                        FR: {
                            id: null,
                            news: {
                                titulo: '',
                                descricao: '',
                                video: ''
                            },
                            i_files: {
                                image_files: [],
                                docs_files: []
                            },
                            questions: [
                                {   
                                    news_question_id: null,
                                    question_type: '1',
                                    question: '',
                                    answer: [
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        },
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        }
                                    ]
                                }
                            ]
                        },
                        BR: {
                            id: null,
                            news: {
                                titulo: '',
                                descricao: '',
                                video: ''
                            },
                            i_files: {
                                image_files: [],
                                docs_files: []
                            },
                            questions: [
                                {   
                                    news_question_id: null,
                                    question_type: '1',
                                    question: '',
                                    answer: [
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        },
                                        {
                                            news_question_id: null,
                                            news_question_option_id: null,
                                            option_text: ''
                                        }
                                    ]
                                }
                            ]
                        },
                        

                    }
                },
                questions: {},
                counterDanger: false,
                id_news: null,
                replyComment: null,
                comment_text: '',
                totalExistingQuestions: {
                    PT: 1,
                    BR: 1,
                    EN: 1,
                    FR: 1,
                    DE: 1,
                    ES: 1
                },
                popupVotes: {
                    show: false,
                    title: '',
                    voters: []
                },
                popupShow: {
                    show: false,
                    content: '',
                    title: '',
                    imgSrc: '',
                    docSrc: ''
                },
                dataHoje: '',
                disabledDatesInicio: {
                    to: null, // Disable all dates up to specific date
                    from: null, // Disable all dates after specific date
                },
                disabledDatesFim: {
                    to: null, // Disable all dates up to specific date
                },
                highlightedFn: {
                    from: null,
                    to: null
                },
                editorOption: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline'],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'indent': '-1'}, {'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{'font': ['montserrat', 'arial', 'comicsans', 'inconsolata', 'monospace', 'serif']}],
                            [{ 'align': [] }],
                            ['link']
                        ]
                    },
                    placeholder: 'Descrição',
                },
			}
		},
		methods: {
            /*
             * Vai buscar a noticia, comentários e perguntas para editar (se for editar)
             */ 
            getNews(id_news){
                this.$vs.loading();
                let token = localStorage.getItem('usertoken');

                this.$api.post( '/myvilagale/news/getNews?token=' + token,
                {
                    news_id: id_news
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then((res) => {
 
                    this.news_form = res.data;
                    this.news_form.data_inicio = this.news_form.data_inicio == null ? null : new Date(res.data.data_inicio);
                    this.news_form.data_fim = this.news_form.data_fim == null ? null : new Date(res.data.data_fim);
                    this.setTotalExistingQuestions();
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },

            setTotalExistingQuestions(){
                this.totalExistingQuestions['PT'] = this.news_form.langs['PT']['questions'].length;
                this.totalExistingQuestions['BR'] = this.news_form.langs['BR']['questions'].length;
                this.totalExistingQuestions['EN'] = this.news_form.langs['EN']['questions'].length;
                this.totalExistingQuestions['FR'] = this.news_form.langs['FR']['questions'].length;
                this.totalExistingQuestions['DE'] = this.news_form.langs['DE']['questions'].length;
                this.totalExistingQuestions['ES'] = this.news_form.langs['ES']['questions'].length;
            },


            /*
             * Limpar campo de datas
             */ 
            clearDate(input){
                this.news_form[input] = null;
            },

            /*
             * Mostrar imagem no chip
             */ 
			generatePath(file) {
				return URL.createObjectURL(file);
			},

            /*
             * Trigger quando a imagem e' selecionada no input file que está escondido
             */ 
			handleFileUploads(file_type, country) {
                let uploadedFiles = this.$refs[file_type+'_'+country][0].files;
                if(file_type == 'image_files'){
                    // Tests if the uploaded file has the right extension
                    if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[0].name)) {
                        //Adds the uploaded file to the files array
                        this.news_form.langs[country].i_files[file_type].push(uploadedFiles[0]);
                    } else {
                        this.notify(this.$t('A_imagem_tem_ser_do_tipo_jpeg_jpg_png_ou_gif'), 'red');
                    }
                }else if(file_type == 'docs_files'){

                    // Tests if the uploaded file has the right extension
                    if (/\.(pdf)$/i.test(uploadedFiles[0].name)) {
                        //Adds the uploaded file to the files array
                        this.news_form.langs[country].i_files[file_type].push(uploadedFiles[0]);
                    } else {
                        this.notify(this.$t('O_ficheiro_tem_de_ser_um_pdf'), 'red');
                    }
                }
			},

			/*
		     * Adds a file
		     */  
			addFiles(file_type, country) {
                if(file_type == 'image_files'){
                    if(this.news_form.langs[country].i_files[file_type].length > 0){
                        this.notify(this.$t('Já_chegou_ao_limite_de_ficheiros'), 'red');
                        return;
                    }
                    
                }else if(file_type == 'docs_files'){
                    if(this.news_form.langs[country].i_files[file_type].length > 2){
                        this.notify(this.$t('Já_chegou_ao_limite_de_ficheiros'), 'red');
                        return;
                    }
                }
                this.$refs[file_type+'_'+country][0].click();
			},

			/*
			 * Removes a select file the user has uploaded
		     */  
			removeFile(key, file_type, country) {
                this.news_form.langs[country].i_files[file_type].splice(key, 1);
			},
            
            /*
             * Questionario: Botoes de adicionar e remover
             */ 
            addQuestion(country){
                this.news_form.langs[country].questions.push(
                    {   
                        news_question_id: null,
                        question_type: '1',
                        question: '',
                        answer: [
                            {
                                news_question_id: null,
                                news_question_option_id: null,
                                option_text: ''
                            },
                            {
                                news_question_id: null,
                                news_question_option_id: null,
                                option_text: ''
                            }
                        ]
                    }
                );
            },
            removeQuestion(country){
                this.news_form.langs[country].questions.pop();
            },
            addAnswer(country, key){
                this.news_form.langs[country].questions[key].answer.push(
                    {
                        news_question_id: null,
                        news_question_option_id: null,
                        option_text: ''
                    }
                );
            },
            removeAnswer(country, key){
                this.news_form.langs[country].questions[key].answer.pop();
            },

            /*
             * Submit do formulario
             */
            submitNews(type){
                var to_return = 0;

                // Datas da noticia
                if(this.news_form.data_inicio == null && this.news_form.data_fim != null){
                    this.notify(this.$t('A_Data_de_Início_não_está_selecionada'), 'red');
                    to_return = 1;
                }
                if(this.news_form.data_inicio != null && this.news_form.data_fim == null){
                    this.notify(this.$t('A_Data_de_Fim_não_está_selecionada'), 'red');
                    to_return = 1;
                }
                
                if(to_return == 1){
                    return false;
                }else{
                    this.$vs.loading();

                    let formData = new FormData();
                    var formulario = this.news_form;
                    if(this.news_form['data_inicio'] === null){
                        formulario['data_i'] = null;
                    }else{
                        var year = this.news_form['data_inicio'].getFullYear();
                        var month = this.news_form['data_inicio'].getMonth()+1;
                        var day = this.news_form['data_inicio'].getDate();
                        formulario['data_i'] = year+'-'+month+'-'+day;
                    }
                    
                    if(this.news_form['data_fim'] === null){
                        formulario['data_f'] = null;
                    }else{
                        year = this.news_form['data_fim'].getFullYear();
                        month = this.news_form['data_fim'].getMonth()+1;
                        day = this.news_form['data_fim'].getDate();
                        formulario['data_f'] = year+'-'+month+'-'+day;
                    }

                    if (formulario.hasOwnProperty('comments')) {
                        delete formulario.comments;
                    }
                    this.buildFormData(formData,  {
                        news_form: formulario, 
                        user: this.user_name, 
                        id_news: this.id_news,
                    });

                    let token = localStorage.getItem('usertoken');

                    this.$api.post( '/myvilagale/news/save?token=' + token,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': 'Bearer ' + token
                        }
                    })
                    .then((res) => {
                        this.$vs.loading.close();

                        if(type == 'create'){
                            this.notify(this.$t('Registo_criado_com_sucesso'), 'green');
                        }else if(type == 'edit'){
                            this.notify(this.$t('Registo_alterado_com_sucesso'), 'green');
                        }
                        this.$router.push({ name: 'list-news'});
                    })
                    .catch((err) => {
                        this.notify(err.response.data.message, 'red', 10);
                        this.$vs.loading.close();
                    });
                }
            },

            buildFormData(formData, data, parentKey) {
                if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                    let that = this;
                    Object.keys(data).forEach(key => {
                        that.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                    });
                } else {
                    const value = data == null ? '' : data;
                    formData.append(parentKey, value);
                }
            },

            /*
             * Mostra ou esconde o comentario
             */
            changeVisibleC(id, visible) {
                this.$vs.loading();
                let token = localStorage.getItem('usertoken');

                this.$api.post( '/myvilagale/news/commentVisible?token=' + token,
                {
                    id: id,
                    visible: visible,
                    news_id: this.id_news
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then((res) => {
                    this.news_form.comments = res.data;
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },

            /*
             * Mostra ou esconde a textarea de resposta
             */
            replyC(index) {
                this.replyComment = (this.replyComment == index ? null : index);
                this.comment_text = '';
            },

            /*
             * Envia comentario
             */
            sendC(index, id_comment) {
                this.$vs.loading();
                let token = localStorage.getItem('usertoken');

                this.$api.post( '/myvilagale/news/saveComment?token=' + token,
                {
                    news_id: this.id_news,
                    person_id: this.user_name.id,
                    comment_text: this.comment_text,
                    reference_id: id_comment,
                    image_file: null,
                    view: 'news-form'
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then((res) => {
                    this.replyC(null);
                    this.news_form.comments = res.data;
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },

            /*
             * Mostra popup dos votos
             */
            popupV(key, key2) {
                this.popupVotes.title = this.news_form.questions[key]['answers'][key2]['answer'];
                this.popupVotes.voters = this.news_form.questions[key]['answers'][key2]['voters'];
                this.popupVotes.show = true;
            },

            /*
             * Mostra popup dos ficheiros
             */
            popupN(content, path){
                if(typeof path['from_db'] === 'undefined'){
                    if(content == 'img'){
                        this.popupShow.imgSrc = this.generatePath(path);
                    }else if(content == 'doc'){
                        this.popupShow.docSrc = this.generatePath(path);
                    }
                }else{
                    if(content == 'img'){
                        this.popupShow.imgSrc = path['path'];
                    }else if(content == 'doc'){
                        this.popupShow.docSrc = path['path'];
                    }
                }
                
                this.popupShow.content = content;
                this.popupShow.title = path.name;
                this.popupShow.show = true;
            },

		},
        watch: {
            // Fix na visualizacao de docs diferentes em popup
            'popupShow.show': function(valor) {
                if(valor == false){
                    this.popupShow.content = '';
                }
            },
            'news_form.data_inicio': function(valor) {
                this.disabledDatesFim.to = valor == null ? this.dataHoje : valor;
                this.highlightedFn.from = valor;
            },
            'news_form.data_fim': function(valor) {
                this.disabledDatesInicio.from = valor;
                this.highlightedFn.to = valor;
            }
        },
		created(){
            let d = new Date();
            this.dataHoje = new Date(d.getFullYear(), d.getMonth(), d.getDate());
            this.disabledDatesInicio.to = this.dataHoje;
            this.disabledDatesFim.to = this.dataHoje;

            /*
             * verifica se estamos em Editar Noticia
             */
			if(typeof this.$route.params.id !== 'undefined'){
                this.id_news = this.$route.params.id;
                this.getNews(this.id_news);
			}

        },
        mounted() {
        },
        components: {
            Datepicker,
            quillEditor,
        }
	}
</script>


<style>

    @media only screen and (max-width: 600px) {
        .mainNewsForm .con-tab.vs-tabs--content{
            padding: 10px 0px 10px 0px;
        }
        .pl10p {
            padding-left: 0%;
        }
        .bottomInputs {
            padding: 10px 0px;
        }
        .mainNewsForm .vx-card .vx-card__collapsible-content .vx-card__body {
            padding: 10px !important;
        }
        .titulo{
            padding-left: 10px;
        }
        .questInputs .card-title{
            padding: 1.5rem 5px 1.5rem 5px !important;
        }
        .questInputs .vx-card .vx-card__collapsible-content .vx-card__body{
            padding: 5px !important;
        }
        .comentario{
            margin-bottom: 40px;
        }
        .mainNewsForm .datasLimite{
            margin-left: 12px !important;
        }
    }

    .mainNewsForm .datasLimiteDiv{
        display: flex;
    }
    .mainNewsForm .datasLimite{
        display: flex;
        margin-bottom: 15px;
        justify-content: center;
    }
    .comentario{
        margin-bottom: 30px;
    }
    .textComment{
        margin-top: 15px;
    }
    .comment_image{
        max-height: 150px;
        max-width: 100%;
        margin-top: 10px;
    }
    .colorG{
        color: #bdbdbd;
    }
    .bottomInputs {
        padding: 10px 30px;
    }
	.inputNews {
		padding-bottom: 12px;
	}
	.otherInputNews {
		padding-top: 1px;
	}
    .news_textarea {
        border: 1px solid rgba(0, 0, 0, 0.2) !important;
        margin-top: 17px;
    }
    .question_text {
        min-height: 150px;
        padding: 1.5rem 1.5rem !important;
    }
    .card-title {
        min-height: 150px;
        padding: 1.5rem 1.5rem !important;
    }
    .giveSpaceNews {
        min-height: 120px;
    }
    .notSidebySide{
        flex-direction: column;
    }
    .r30{
        right: 30px;
    }
    .w80p {
        width: 80%;
    }
    .w20p {
        width: 20%;
    }
    .mt0 {
        margin-top: 0px;
    }
	.mt15 {
        margin-top: 15px;
    }
	.mt25 {
        margin-top: 25px;
    }
    .mt25i {
        margin-top: 25px !important;
    }
    .mr10{
        margin-right: 10px;
    }
    .mr15{
        margin-right: 15px;
    }
    .mr25{
        margin-right: 25px;
    }
    .mr40{
        margin-right: 40px;
    }
    .mb10 {
        margin-bottom: 10px;
    }
    .mb15{
        margin-bottom: 15px;
    }
    .mb20{
        margin-bottom: 20px;
    }
    .mb40{
        margin-bottom: 40px;
    }
    .mb80 {
        margin-bottom: 80px;
    }
    .mb25i{
        margin-bottom: 25px !important;
    }
    .ml15 {
        margin-left: 15px;
    }
    .p0020{
        padding: 0 0 2px 0 !important;
    }
    .pl10p {
        padding-left: 10%;
    }
    .pl15 {
        padding-left: 15px;
    }
    .plr20 {
        padding-left: 20px;
        padding-right: 20px;
    }
    .pb15r {
        padding-bottom: 1.5rem !important;
    }
    .pb25 {
        padding-bottom: 25px !important;
    }
    .pr15 {
        padding-right: 15px !important;
    }
    .pr1r {
        padding-right: 1rem !important;
    }
    .fs26 {
        font-size: 26px;
    }
    .vs-component.vs-con-textarea.vs-textarea-primary h4{
        color: #bdbdbd;
    }
    .giveSpaceNews:not(.notSidebySide) div .con-vs-chip.vs-chip-primary.closable.con-color .text-chip .con-vs-avatar{
        height: 35px;
        width: 35px;
    }
    .vs-notifications h3{
        padding: 0;
    }
    .wPopupShow .vs-popup{
        width: 1000px !important;
    }
    .fix-layer {
        overflow: visible !important;
    }
    .fix-layer .con-slot-tabs{
        overflow: visible !important;
    }


    .ql-editor {
        height: 300px;
    }
    .editorSpace{
        margin-bottom: 10px;
    }

</style>
